import { Backdrop } from '@material-ui/core'
import './Modal.scoped.scss'

const Modal = ({
  open,
  title,
  onCancel,
  children,
  autoWidth = false,
  fitContentWidth=false,
  defaultWider = false,
  autoHeight = false,
  extraClass
}) => {
  const classNames = ['modal-root']
  if (autoWidth) classNames.push('auto-width')
  if (fitContentWidth) classNames.push('fit-content-width')
  if (defaultWider) classNames.push('default-wider')
  if (autoHeight) classNames.push('auto-height')
  if (extraClass) classNames.push(extraClass)

  return (
    <Backdrop open={open} style={{ zIndex: 1000 }}>
      <div maxwidth="md" className={classNames.join(' ')}>
        <div className="modal-title-bar">
          <h1>{title}</h1>
          <button className="button naked close-modal" type="button" onClick={onCancel}><SvgIconsClose className='no-margin' /></button>
        </div>
        <div className="modal-content">{children}</div>
      </div>
    </Backdrop>
  )
}

export default Modal
